import {EventStaticLandingPageVo} from '../../common/shared/api/karina/vo/page/EventStaticLandingPageVo.interface';
import {
  GroupType,
  LayoutType,
  Maybe,
  SectionType,
  StaticLandingEventParamInput,
  StaticLandingEventSection,
  StaticLandingType,
  User,
} from '../generated/types';
import {createCardViewItem} from './CardViewItem';
import {createSortOption} from './SortOption';

export function createStaticLandingEventSection(
  userInfo: Maybe<User>,
  {
    sectionId,
    eventStaticLandingPageVo,
    input,
    type = LayoutType.Landing,
  }: {
    sectionId?: string;
    eventStaticLandingPageVo: EventStaticLandingPageVo;
    input: StaticLandingEventParamInput;
    type?: LayoutType;
  }
): StaticLandingEventSection {
  const {categoryUid, page} = input;

  return {
    id:
      sectionId ||
      `static-landing-${StaticLandingType.Event}-section-${type}-${categoryUid}`,
    type: SectionType.LandingEvent,
    groups: [
      {
        id: `static-landing-${StaticLandingType.Event}-group-${categoryUid}`,
        type: GroupType.CardView,
        items:
          eventStaticLandingPageVo.list?.map(item =>
            createCardViewItem(userInfo, {
              bannerItemDto: item,
            })
          ) || [],
      },
    ],
    categoryTabList:
      eventStaticLandingPageVo.cat_opt_list?.map(opt =>
        createSortOption({filterOptionVo: opt})
      ) || [],
    isEnd: eventStaticLandingPageVo.is_end,
    totalCount: eventStaticLandingPageVo.total_count,
    param: {
      page,
      categoryUid,
    },
  };
}
